import log from "./log";
import { LOG_LEVEL_ERROR, LOG_LEVEL_WARN, LOG_LEVEL_INFO } from "./constants";

export const logError = log.bind(null, LOG_LEVEL_ERROR);
export const logWarning = log.bind(null, LOG_LEVEL_WARN);
export const logInfo = log.bind(null, LOG_LEVEL_INFO);
